import React from 'react';
import { Phone, ArrowRight } from 'lucide-react';
import { businessInfo } from '../data/mock';
import { Button } from './ui/button';

const FinalCTASection = () => {
  return (
    <section className="py-20 md:py-28 bg-amber-500 relative overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute inset-0" style={{
          backgroundImage: `url("data:image/svg+xml,%3Csvg width='40' height='40' viewBox='0 0 40 40' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='%23000000' fill-opacity='1' fill-rule='evenodd'%3E%3Cpath d='M0 40L40 0H20L0 20M40 40V20L20 40'/%3E%3C/g%3E%3C/svg%3E")`
        }}></div>
      </div>

      <div className="relative max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-slate-900 mb-6">
          Need a Trusted Locksmith in South Perth?
        </h2>
        <p className="text-xl text-slate-800 mb-10 max-w-2xl mx-auto">
          Don't wait – get prompt, professional locksmith services from DC Lock and Key. We're ready to help!
        </p>

        <a href={businessInfo.phoneLink}>
          <Button
            size="lg"
            className="bg-slate-900 hover:bg-slate-800 text-white font-bold text-xl px-10 py-7 gap-3 shadow-xl hover:shadow-2xl transition-all group"
          >
            <Phone className="w-6 h-6" />
            Call {businessInfo.phone}
            <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" />
          </Button>
        </a>

        <p className="mt-6 text-slate-800 font-medium">
          Available Mon–Fri 7am–6pm • Sat–Sun 7am–1pm
        </p>
      </div>
    </section>
  );
};

export default FinalCTASection;
